import styled from 'styled-components'

import { Skeleton } from '@syconium/little-miss-figgy'

export const GalleryImageCarouselWrapper = styled.div`
  height: fit-content;
  position: sticky;
  top: 88px;
  width: 100%;
`

export const GalleryImageCarouselContentWrapper = styled.div`
  display: flex;
`

export const GalleryThumbnailsWrapper = styled.div`
  padding-inline-start: 40px;
  padding-inline-end: 16px;
  width: 100px;
`

export const CurrentCarouselSlideWrapper = styled.div`
  height: 100%;
  width: 100%;
`

export const CurrentCarouselSlideSkeleton = styled(Skeleton)`
  padding-bottom: 100%;
`
